import { createContext, useContext, useCallback } from 'react';

const tr = {
  // Common
  save: 'Kaydet', cancel: 'İptal', delete: 'Sil', edit: 'Düzenle', add: 'Ekle',
  search: 'Ara', filter: 'Filtrele', loading: 'Yükleniyor...', noData: 'Veri bulunamadı',
  confirm: 'Onayla', close: 'Kapat', actions: 'İşlemler', status: 'Durum', date: 'Tarih',
  name: 'Ad', email: 'E-posta', phone: 'Telefon', password: 'Şifre', all: 'Tümü',
  yes: 'Evet', no: 'Hayır', back: 'Geri', next: 'İleri', reset: 'Sıfırla',
  refresh: 'Yenile', download: 'İndir', update: 'Güncelle', create: 'Oluştur',
  export: 'Dışa Aktar', import: 'İçe Aktar', details: 'Detaylar', total: 'Toplam',
  active: 'Aktif', inactive: 'Pasif', enable: 'Etkinleştir', disable: 'Devre Dışı',
  success: 'Başarılı', error: 'Hata', warning: 'Uyarı', info: 'Bilgi',
  required: 'zorunlu', optional: 'opsiyonel', none: 'Yok', notSpecified: 'Belirtilmemiş',
  noResult: 'Arama sonucu bulunamadı', showing: 'Gösteriliyor', of: '/',
  previous: 'Önceki', connectionError: 'Bağlantı hatası',

  // Auth
  login: 'Giriş Yap', logout: 'Çıkış Yap', register: 'Kayıt Ol',
  loginTitle: 'Hesabınıza giriş yapın', loginSubtitle: 'E-posta ve şifrenizle giriş yapın',
  registerTitle: 'Yeni hesap oluşturun', registerSubtitle: 'Firmanızı kaydedin ve hemen kullanmaya başlayın',
  emailPlaceholder: 'E-posta adresiniz', passwordPlaceholder: 'Şifreniz',
  passwordMin: 'En az 8 karakter, büyük/küçük harf, rakam',
  confirmPassword: 'Şifreyi Onaylayın', confirmPasswordPlaceholder: 'Şifrenizi tekrar girin',
  companyName: 'Firma Adı', companyNamePlaceholder: 'Firmanızın adı',
  fullName: 'Ad Soyad', fullNamePlaceholder: 'Adınız ve soyadınız',
  phonePlaceholder: 'Telefon numaranız',
  invalidCredentials: 'Geçersiz email veya şifre',
  accountDisabled: 'Hesabınız devre dışı bırakılmış',
  alreadyHaveAccount: 'Zaten hesabınız var mı?',
  dontHaveAccount: 'Hesabınız yok mu?',
  loggingIn: 'Giriş yapılıyor...',
  registering: 'Kayıt yapılıyor...',
  freeTrial: '7 Gün Ücretsiz Deneme',
  freeTrialDesc: 'Kredi kartı gerekmez',
  welcomeTitle: 'Ödeme Takip Sistemi',
  welcomeSubtitle: 'WhatsApp entegrasyonlu ödeme sözü takip ve tahsilat hatırlatma platformu',
  feature1: 'WhatsApp ile otomatik hatırlatma',
  feature2: 'Canlı dashboard ve raporlama',
  feature3: 'Güvenli ve KVKK uyumlu',
  kvkkConsent: 'KVKK Aydınlatma Metni',
  privacyConsent: 'Gizlilik Politikası',
  membershipConsent: 'Üyelik Sözleşmesi',
  readAndAccept: "nı okudum ve kabul ediyorum",
  consentRequired: 'Devam etmek için tüm sözleşmeleri kabul etmelisiniz',
  nameRequired: 'Ad soyad zorunlu',
  emailRequired: 'E-posta zorunlu',
  companyRequired: 'Firma adı zorunlu',
  phoneRequired: 'Firma telefon zorunlu',
  passwordsNotMatch: 'Şifreler eşleşmiyor',
  passwordMinLength: 'Şifre en az 8 karakter olmalı',
  passwordNeedUpper: 'Şifre en az bir büyük harf içermelidir',
  passwordNeedLower: 'Şifre en az bir küçük harf içermelidir',
  passwordNeedDigit: 'Şifre en az bir rakam içermelidir',
  emailInvalid: 'Geçerli bir e-posta adresi girin',

  // Navigation
  dashboard: 'Genel Bakış', customers: 'Cariler', payments: 'Ödeme Sözleri',
  whatsapp: 'WhatsApp', personnel: 'Personel', settings: 'Ayarlar',
  profile: 'Profil', reports: 'Raporlar', todayCollected: "Tahsilatlar",
  collected: 'Tahsil Edilenler',

  // Admin Navigation
  companies: 'Firmalar', packages: 'Paket Yönetimi', paymentMethods: 'Ödeme Yöntemleri',
  users: 'Kullanıcılar', whatsappManagement: 'WhatsApp Yönetimi',
  messageLogs: 'Mesaj Logları', messageTemplates: 'Mesaj Şablonları',
  securityLogs: 'Güvenlik Logları', systemSettings: 'Sistem Ayarları',
  adminPanel: 'Admin Panel',

  // Dashboard
  pending: 'Bekleyen', todayDue: 'Bugün Vadesi', overdue: 'Geciken',
  dailyMessage: 'Günlük Mesaj', monthlyMessage: 'Aylık Mesaj',
  sentLimit: 'Gönderilen/Limit', todayDueDesc: 'Bugün vadesi gelen',
  todayCollectedDesc: 'Bugün tahsil edilen', paymentsLabel: 'ödeme',
  recentPayments: 'Son Ödeme Sözleri', upcomingDues: 'Yaklaşan Vadeler',
  quickActions: 'Hızlı İşlemler', newCustomer: 'Yeni Cari',
  newPayment: 'Yeni Ödeme Sözü', connectWhatsApp: 'WhatsApp Bağla',
  viewAll: 'Tümünü Gör', noUpcomingDue: 'Bugün vadesi gelen ödeme yok',
  collectionReport: 'Tahsilat Raporu', paymentReport: 'Ödeme Raporu',
  monthlyChart: 'Aylık Grafik', personnelPerf: 'Personel Performansı',
  totalCollected: 'Toplam Tahsilat', collectionRate: 'Tahsilat Oranı',
  totalAmount: 'Toplam Tutar', paidAmount: 'Ödenen Tutar',
  remainingAmount: 'Kalan Tutar',

  // Admin Dashboard
  totalCompanies: 'Toplam Firma', trial: 'Deneme', expired: 'Süresi Dolan',
  pendingTransfer: 'Havale Bekliyor', totalUsers: 'Toplam Kullanıcı',
  totalCustomers: 'Toplam Cari', totalPayments: 'Toplam Ödeme',
  whatsappConnected: 'WhatsApp Bağlı', messagesToday: 'Mesaj (Bugün)',
  messagesMonth: 'Mesaj (Bu Ay)', conversionRate: 'Dönüşüm Oranı',
  avgUsers: 'Ort. Kullanıcı', activeSubscription: 'aktif abonelik',
  activeTrial: 'Aktif deneme', subscriptionNeeded: 'Abonelik gerekli',
  awaitingApproval: 'Onay bekleniyor', perCompany: 'Firma başına',
  trialToSub: 'Deneme -> Abonelik', subscriptionRevenue: 'Toplam Abonelik Geliri',
  monthlyRevenue: 'Bu Ay Gelir', fromActiveSubscriptions: 'aktif abonelikten',
  newSubscriptionsThisMonth: 'Bu ay yeni abonelikler',

  // Customers
  addCustomer: 'Yeni Cari Ekle', customerName: 'Cari Adı',
  customerPhone: 'Telefon', customerEmail: 'E-posta', customerAddress: 'Adres',
  customerNotes: 'Notlar', editCustomer: 'Cari Düzenle', deleteCustomer: 'Cariyi Sil',
  deleteCustomerConfirm: 'Bu cariyi silmek istediğinize emin misiniz?',
  customerCreated: 'Cari oluşturuldu', customerUpdated: 'Cari güncellendi',
  customerDeleted: 'Cari silindi', noCustomers: 'Henüz cari eklenmemiş',
  updateCustomerInfo: 'Cari bilgilerini güncelleyin',
  searchCustomer: 'Cari ara...', nameEmpty: 'Ad boş olamaz',
  customersTitle: 'Cariler', customersDesc: 'Müşteri listesi ve yönetimi',
  totalCustomersCount: 'Toplam Cari',

  // Payments
  addPayment: 'Yeni Ödeme Sözü', customer: 'Cari', amount: 'Tutar',
  dueDate: 'Vade Tarihi', description: 'Açıklama', paymentStatus: 'Ödeme Durumu',
  statusPending: 'Bekliyor', statusPaid: 'Ödendi', statusOverdue: 'Gecikti',
  statusCancelled: 'İptal', markAsPaid: 'Ödendi İşaretle', sendReminder: 'Hatırlat',
  sendWhatsApp: 'WhatsApp mesajı gönder',
  duplicatePaymentWarning: 'Bu cari için zaten bekleyen bir ödeme sözü var. Devam etmek istiyor musunuz?',
  createAnyway: 'Yine de oluştur', noPayments: 'Henüz ödeme sözü yok',
  paymentCreated: 'Ödeme sözü oluşturuldu', paymentUpdated: 'Ödeme sözü güncellendi',
  reminderSent: 'Hatırlatma mesajı gönderildi', selectCustomer: 'Cari seçin',
  amountRequired: 'Tutar zorunlu', dueDateRequired: 'Vade tarihi zorunlu',
  exportNoData: 'Dışa aktarılacak veri yok', exported: 'Dışa aktarıldı',
  exportFailed: 'Dışa aktarma başarısız', paymentsTitle: 'Ödeme Sözleri',
  paymentsDesc: 'Ödeme takibi ve hatırlatma yönetimi',
  duplicateWarningTitle: 'Bekleyen Ödeme Sözü Var',
  cancelPayment: 'Ödemeyi İptal Et', paymentNotes: 'Ödeme Notu',
  filterByStatus: 'Duruma göre filtrele', filterByDate: 'Tarihe göre filtrele',

  // WhatsApp
  connectionStatus: 'Bağlantı Durumu', connected: 'Bağlı',
  disconnected: 'Bağlı Değil', connecting: 'Bağlanıyor...',
  scanQR: 'QR Kodu Tarayın', disconnect: 'Bağlantıyı Kes',
  connectDevice: 'Cihaz Bağla', whatsappTitle: 'WhatsApp Bağlantısı',
  whatsappDesc: 'WhatsApp hesabınızı bağlayın',
  qrInstructions: 'WhatsApp uygulamasını açın',
  qrStep1: 'Ayarlar > Bağlı Cihazlar menüsüne gidin',
  qrStep2: 'Cihaz Bağla seçeneğine tıklayın',
  qrStep3: 'Ekrandaki QR kodu telefonunuzla okutun',
  disconnectConfirm: 'Bağlantıyı kesmek istediğinize emin misiniz?',
  disconnectError: 'Bağlantı kesme hatası',
  manualMessage: 'Manuel Mesaj',
  selectCustomerForMsg: 'Mesaj göndermek için cari seçin',
  messageText: 'Mesaj metni', sendMessage: 'Mesaj Gönder',
  messageSent: 'Mesaj gönderildi', messageFailed: 'Mesaj gönderilemedi',
  sending: 'Gönderiliyor...',

  // Personnel
  addPersonnel: 'Personel Ekle', role: 'Rol',
  roleAdmin: 'Yönetici', rolePersonnel: 'Personel',
  noPersonnel: 'Henüz personel eklenmemiş',
  personnelCreated: 'Personel oluşturuldu', personnelUpdated: 'Personel güncellendi',
  personnelDeleted: 'Personel silindi', editPersonnel: 'Personel Düzenle',
  deletePersonnel: 'Personeli Sil',
  deletePersonnelConfirm: 'Bu personeli silmek istediğinize emin misiniz?',
  personnelTitle: 'Personel Yönetimi', personnelDesc: 'Personel listesi ve yetkilendirme',
  updatePersonnelPassword: 'Yeni şifre (boş bırakılırsa değişmez)',
  companyAdmin: 'Firma Yöneticisi',

  // Settings
  companyInfo: 'Firma Bilgileri', taxNumber: 'Vergi No', taxOffice: 'Vergi Dairesi',
  address: 'Adres', logoUpload: 'Logo Yükle', cronSettings: 'Hatırlatma Saati',
  cronHour: 'Saat', cronMinute: 'Dakika', settingsSaved: 'Ayarlar kaydedildi',
  settingsTitle: 'Firma Ayarları', settingsDesc: 'Firma bilgileri ve genel ayarlar',
  logoSection: 'Firma Logosu', changeLogoDesc: 'Logo yüklemek için tıklayın',
  subscription: 'Abonelik', subscriptionInfo: 'Abonelik Bilgileri',
  currentPlan: 'Mevcut Plan', renewSubscription: 'Aboneliği Yenile',
  subscriptionStatus: 'Abonelik Durumu', trialPeriod: 'Deneme Süresi',
  daysLeft: 'gün kaldı', subscriptionActive: 'Aktif Abonelik',
  subscriptionExpired: 'Abonelik Süresi Doldu', havaleApproval: 'Havale Onayı Bekliyor',
  renewalRequest: 'Abonelik yenileme talebiniz alındı',
  companyNameLabel: 'Firma Adı', emailLabel: 'E-posta', phoneLabel: 'Telefon',
  addressLabel: 'Adres', taxNumberLabel: 'Vergi No', taxOfficeLabel: 'Vergi Dairesi',
  reminderTimeDesc: 'Her gün bu saatte hatırlatma mesajı gönderilir',
  saveSettings: 'Ayarları Kaydet', saving: 'Kaydediliyor...',

  // Profile
  changePassword: 'Şifre Değiştir', currentPassword: 'Mevcut Şifre',
  newPassword: 'Yeni Şifre', confirmNewPassword: 'Yeni Şifre (Tekrar)',
  passwordChanged: 'Şifre değiştirildi. Lütfen tekrar giriş yapın.',
  passwordChangeFailed: 'Şifre değiştirilemedi',
  profileTitle: 'Profil', profileDesc: 'Kişisel bilgiler ve şifre değiştirme',
  personalInfo: 'Kişisel Bilgiler', profileUpdated: 'Profil güncellendi',
  profileUpdateFailed: 'Profil güncellenemedi',
  allFieldsRequired: 'Tüm alanları doldurun',
  newPasswordsNotMatch: 'Yeni şifreler eşleşmiyor',

  // Security
  securityLogsTitle: 'Güvenlik Logları', securityLogsDesc: 'Giriş denemeleri ve güvenlik olayları',
  totalAttempts: 'Toplam Deneme', successful: 'Başarılı', failed: 'Başarısız',
  loginAttempts: 'Giriş Denemeleri', last100Attempts: 'Son 100 giriş denemesi',
  wrongPassword: 'Yanlış şifre', userNotFound: 'Kullanıcı bulunamadı',
  noLogsYet: 'Henüz giriş logu yok',

  // Theme
  lightMode: 'Açık Mod', darkMode: 'Koyu Mod',

  // Language
  language: 'Dil', turkish: 'Türkçe', english: 'English',

  // Collected Page
  collectedTitle: 'Tahsil Edilenler', collectedDesc: 'Tahsil edilen ödemeler',
  noCollected: 'Henüz tahsil edilen ödeme yok', collectedDate: 'Tahsilat Tarihi',
  collectedAmount: 'Tahsil Edilen', paidBy: 'Tahsil Eden',

  // Suspended / Trial Expired
  accountSuspended: 'Hesap Askıya Alındı',
  suspendedMessage: 'Firma hesabınız askıya alınmıştır. Lütfen yöneticinizle iletişime geçin.',
  trialExpired: 'Deneme Süresi Doldu',
  trialExpiredMessage: '7 günlük ücretsiz deneme süreniz dolmuştur.',
  contactAdmin: 'Yönetici ile İletişim',
  goToSubscription: 'Abonelik Sayfasına Git',

  // Admin Companies
  adminCompaniesTitle: 'Firma Yönetimi', adminCompaniesDesc: 'Tüm firmaları yönetin',
  companyStatus: 'Firma Durumu', trialStatus: 'Deneme', activeStatus: 'Aktif',
  expiredStatus: 'Süresi Doldu', suspendedStatus: 'Askıda',
  pendingPayment: 'Havale Bekleniyor',
  activate: 'Aktifleştir', suspend: 'Askıya Al', unsuspend: 'Askıyı Kaldır',
  approvePayment: 'Havaleyi Onayla', rejectPayment: 'Havaleyi Reddet',
  companyDetails: 'Firma Detayları', userCount: 'Kullanıcı Sayısı',
  customerCount: 'Cari Sayısı', paymentCount: 'Ödeme Sayısı',
  createdDate: 'Kayıt Tarihi', trialEnd: 'Deneme Bitiş',
  subscriptionEnd: 'Abonelik Bitiş', package: 'Paket',

  // Admin Users
  adminUsersTitle: 'Kullanıcı Yönetimi', adminUsersDesc: 'Tüm kullanıcıları yönetin',
  resetPassword: 'Şifre Sıfırla', deactivate: 'Devre Dışı Bırak',
  reactivate: 'Tekrar Aktifleştir', userRole: 'Kullanıcı Rolü',
  lastLogin: 'Son Giriş', registrationDate: 'Kayıt Tarihi',

  // Admin Packages
  adminPackagesTitle: 'Paket Yönetimi', adminPackagesDesc: 'Abonelik paketlerini yönetin',
  addPackage: 'Yeni Paket', editPackage: 'Paket Düzenle', deletePackage: 'Paketi Sil',
  packageName: 'Paket Adı', packagePrice: 'Fiyat (Yıllık)',
  maxUsers: 'Maks. Kullanıcı', maxCustomers: 'Maks. Cari',
  maxDailyMsg: 'Günlük Mesaj Limiti', maxMonthlyMsg: 'Aylık Mesaj Limiti',
  packageFeatures: 'Özellikler', isActive: 'Aktif mi?',
  packageCreated: 'Paket oluşturuldu', packageUpdated: 'Paket güncellendi',
  packageDeleted: 'Paket silindi', noPackages: 'Henüz paket tanımlanmamış',

  // Admin Payment Methods
  adminPaymentMethodsTitle: 'Ödeme Yöntemleri',
  adminPaymentMethodsDesc: 'Ödeme yöntemlerini yönetin',
  bankTransfer: 'Havale/EFT', creditCard: 'Kredi Kartı',
  bankName: 'Banka Adı', accountHolder: 'Hesap Sahibi',
  iban: 'IBAN', branchCode: 'Şube Kodu', accountNumber: 'Hesap No',

  // Admin Messages
  adminMessagesTitle: 'Mesaj Logları', adminMessagesDesc: 'Gönderilen mesaj kayıtları',
  messageType: 'Mesaj Tipi', recipient: 'Alıcı', sentDate: 'Gönderim Tarihi',
  messageStatus: 'Durum', sent: 'Gönderildi', failedToSend: 'Gönderilemedi',
  pendingMsg: 'Beklemede',

  // Admin Templates
  adminTemplatesTitle: 'Mesaj Şablonları', adminTemplatesDesc: 'Şablon mesajları düzenleyin',
  templateName: 'Şablon Adı', templateContent: 'Şablon İçeriği',
  saveTemplate: 'Şablonu Kaydet', resetTemplate: 'Varsayılana Dön',
  templateSaved: 'Şablon kaydedildi', templateReset: 'Şablon sıfırlandı',

  // Admin Settings
  adminSettingsTitle: 'Sistem Ayarları', adminSettingsDesc: 'Genel sistem yapılandırması',
  brandColor: 'Marka Rengi', brandColorDesc: 'Uygulamanın ana rengini belirleyin',
  siteName: 'Site Adı', siteDescription: 'Site Açıklaması',
  maintenanceMode: 'Bakım Modu', enableMaintenance: 'Bakım modunu etkinleştir',

  // Admin WhatsApp
  adminWhatsAppTitle: 'WhatsApp Sistem Yönetimi',
  adminWhatsAppDesc: 'Sistem düzeyinde WhatsApp bağlantısı ve otomasyonu',
  systemConnection: 'Sistem Bağlantısı', automationSettings: 'Otomasyon Ayarları',
  broadcastMessage: 'Toplu Duyuru', messageQueue: 'Mesaj Kuyruğu',
  welcomeMessage: 'Hoş Geldin Mesajı', trialStartMessage: 'Deneme Başlangıç Mesajı',
  trialEndMessage: 'Deneme Bitiş Uyarısı', subscriptionActiveMsg: 'Abonelik Aktifleştirme',
  sendBroadcast: 'Duyuru Gönder', broadcastTarget: 'Hedef Kitle',
  allUsers: 'Tüm Kullanıcılar', activeUsers: 'Aktif Kullanıcılar',
  trialUsers: 'Deneme Kullanıcıları',

  // Landing Page
  heroTitle: 'Ödeme Sözü Takip Sistemi',
  heroSubtitle: 'WhatsApp entegrasyonlu ödeme sözü takip ve tahsilat hatırlatma sistemi',
  getStarted: 'Hemen Başlayın', features: 'Özellikler',
  pricing: 'Fiyatlandırma', faq: 'SSS', aboutUs: 'Hakkımızda',
  allRightsReserved: 'Tüm hakları saklıdır.',

  // Legal
  legalTitle: 'Yasal Metinler',
  kvkkTitle: 'KVKK Aydınlatma Metni',
  privacyTitle: 'Gizlilik Politikası',
  membershipTitle: 'Üyelik Sözleşmesi',

  // Topbar
  notifications: 'Bildirimler', noNotifications: 'Yeni bildirim yok',
  announcements: 'Duyurular', noAnnouncements: 'Henüz duyuru yok',
  viewProfile: 'Profili Görüntüle',

  // Table / Pagination
  rowsPerPage: 'Sayfa başına',  page: 'Sayfa',
  firstPage: 'İlk Sayfa', lastPage: 'Son Sayfa',

  // Time
  today: 'Bugün', yesterday: 'Dün', thisWeek: 'Bu Hafta',
  thisMonth: 'Bu Ay', lastMonth: 'Geçen Ay', custom: 'Özel',
  startDate: 'Başlangıç', endDate: 'Bitiş',

  // Currency
  currency: 'TL', currencySymbol: '₺',
};

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const t = useCallback((key) => {
    return tr[key] || key;
  }, []);

  return (
    <I18nContext.Provider value={{ t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) return { t: (key) => tr[key] || key };
  return ctx;
};
